import { useQuery } from '@apollo/client';
import { GET_LIST_OF_EQUIPMENT_BY_VO_ID } from '../api/equipment';

export function useVOEquipment(VOID: string) {
  const { data, loading } = useQuery(GET_LIST_OF_EQUIPMENT_BY_VO_ID, {
    variables: {
      VOId: VOID,
    },
  });

  return {
    equipments: data?.equipments ?? [],
    isLoading: loading,
  };
}
